import LoginWindow from './LoginWindow';

export default LoginWindow;
